module.exports = __webpack_public_path__ + "media/images/competitions/cancercommons_logo-3ee8b8169501b866f2105e8f9591b2ee.png";